// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1yRvW","head":"ProcedureTableInfo_head__1aSqI"};